/**
 * created by wang lei
 特殊字符页面
 *
 */
import React, {Component} from 'react';
import specificSymbol from './specificSymbol.png';
import {Modal, Tabs} from "antd";
import {symbolsConfig} from "./specificSymbol-config";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";
const { TabPane } = Tabs;
export default class SpecificSymbolTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            item:''
        }
    }

    render() {
        return (
            <>
                <span style={{cursor: "pointer"}} type="primary"
                      onClick={() => {
                          this.setState({visible: true})
                      }}>
                    <img className={"editor-specialCharacter-tool-btn"} src={specificSymbol}/>
                    <style>{`
                        .editor-specialCharacter-tool-btn{
                            border: 1px solid #f2f6fc
                        }
                        .editor-specialCharacter-tool-btn:hover{
                            border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                        }
                        .editor-specialCharacter-tool-btn:active{
                            border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                        }
                    `}</style>
                </span>
                <Modal
                    title="特殊字符"
                    visible={this.state.visible}
                    keyboard={false}
                    maskClosable={false}
                    onCancel={() => {
                        this.setState({visible: false})
                    }}
                    footer={null}
                    width={622}
                >
                    {this.TabRender()}
                </Modal>
            </>
        )
    }

    TabRender(){
        return(
            <Tabs className={'tabsList'} type="card" size={'small'} style={{height:445}}>
                {
                    symbolsConfig.map((item)=>
                        <TabPane tab={item.title} key={item.name}>
                            <div style={{}}>
                                {item.content[0].split(",").map((item3,index)=>{
                                        return <span key={item3} style={{margin: '5px 3px',textAlign: 'center',display: 'inline-block',width: 40,height: 16,lineHeight: '16px',cursor: 'pointer'}}
                                                     onClick={()=>{
                                                         this.props.editor.execCommand( 'inserthtml',item3);
                                                         this.setState({visible: false})
                                                     }}
                                        >{item3}</span>
                                    })
                                }
                            </div>
                        </TabPane>
                    )
                }
            </Tabs>
        )
    }
}